export interface Measure {
  code: string;
  fullName: string;
  shortName: string;
  class: string;
  classOptions?: MeasureClassOptions;
  impactMeasureCode?: string;
  impactMeasure?: Measure;
  growthMeasureRelativeCode?: string;
  relativeGrowthMeasure?: Measure;
  growthMeasureAbsoluteCode?: string;
  absoluteGrowthMeasure?: Measure;
  alignment?: Alignment;
}

export enum Alignment {
  Aligned = 1,
  Opposite = -1
}

export interface MeasureClass {
  name: string;
}

export interface MeasureClassOptions extends Intl.NumberFormatOptions {
  locales: string,
  maximumFractionDigits: number,
  minimumFractionDigits: number,
  useGrouping: boolean,
  notation: 'standard' | 'scientific' | 'engineering' | 'compact' | undefined,
  signDisplay: keyof Intl.NumberFormatOptionsSignDisplayRegistry | undefined,
  style: keyof Intl.NumberFormatOptionsStyleRegistry | undefined,
  currency: string,
  currencyDisplay: keyof Intl.NumberFormatOptionsCurrencyDisplayRegistry | undefined,
  thousandSeparators: string,
  multiplier: number,
  prefix: string,
  suffix: string,
}
